import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import * as mongoose from 'mongoose';
import { prop } from '@typegoose/typegoose';

export class RelativeTimeRange {
  @prop({ required: true })
  public lastNumDays: number;
}

export class AbsoluteTimeRange {
  @prop({ required: false })
  public fromTimestamp?: number;

  @prop({ required: false })
  public toTimestamp?: number;
}

export class TimeRange {
  @prop({ required: true, enum: TimeRangeKind, type: mongoose.Schema.Types.Number })
  public kind: TimeRangeKind;

  @prop({ type: RelativeTimeRange, _id: false })
  public relative?: RelativeTimeRange;

  @prop({ type: AbsoluteTimeRange, _id: false })
  public absolute?: AbsoluteTimeRange;
}
